module.exports = {"1":"Плохо","2":"Ниже среднего","3":"Средне","4":"Отлично","5":"Замечательно","1.5":"Плохо","2.5":"Ниже среднего","3.5":"Средне","4.5":"Замечательно"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/resources/localization/ru-RU/star-ratings.json
// module id = 1335
// module chunks = 0